import { Grid, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";
import { TopRow } from "../TopRow";
import { BodyTextM } from "../Typography";

export const SharesAccountHeaderGrid = styled(Grid)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(7),
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        gap: theme.spacing(1),
    },
}));

export const SharesAccountHeaderTopRow = styled(TopRow)({});

export const SharesAccountHeaderTitleRow = styled(Stack)(() => ({
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    "& .MuiIconButton-root": {
        padding: 0,
    },
}));

type SharesAccountHeaderTitleProps = {
    $alignTitleLeft?: boolean;
};

export const SharesAccountHeaderTitle = styled(
    BodyTextM,
    styledOmitPropsOptions,
)<SharesAccountHeaderTitleProps>(({ $alignTitleLeft }) => ({
    textAlign: $alignTitleLeft ? "left" : "right",
    fontWeight: "bold",
}));

export const SharesAccountHeaderRow = styled(Stack)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "baseline",
    marginTop: theme.spacing(3),
}));

export const SharesAccountHeaderLabel = styled(BodyTextM)(() => ({
    textAlign: "left",
}));

export const SharesAccountHeaderValue = styled(BodyTextM)(() => ({
    textAlign: "right",
    fontWeight: "bold",
}));
